import { style } from 'typestyle'
export const fw700 = style({ fontWeight: 700 })
